import actions from '@/features/job/store/job.store.actions'
import getters from '@/features/job/store/job.store.getters'
import mutations from '@/features/job/store/job.store.mutations'
import { JOB_STATUSES } from '@/constants'

export interface IProcessingErrors {
  line: number,
  project: number,
  errors: any[]
}
export interface IMeta {
  originalFileUrl?: string
  originalName?: string
  sample?: any[]
  processingErrors?: IProcessingErrors[]
  processingErrorsCount: number
  csvValidationErrors? : any
}

export interface IJob {
  customerId: string,
  jobId: string,
  status: string,
  authorId: string,
  createdAt: number,
  meta: IMeta
}

export interface IJobStore {
  job: IJob,
  selectedJob: IJob | null,
  list: IJob[]
}

export interface IJobId {
  jobId: string
}

export const state: IJobStore = {
  job: {
    customerId: '',
    jobId: '',
    status: JOB_STATUSES.PENDING,
    authorId: '',
    createdAt: 0,
    meta: {
      sample: [],
      processingErrors: [],
      processingErrorsCount: 0,
      csvValidationErrors: {}
    }
  },
  selectedJob: null,
  list: []
}

export default {
  state,
  actions,
  getters,
  mutations
}
